import axiosInstance from "../axiosInstance";

// Post data for Create Manager
export const createCompanyManager = async (formdata) => {
  try {
    const response = await axiosInstance.post(
      "/UserManagement/AddCompanyManager",
      formdata
    );

    return response.data;
  } catch (error) {
    return error;
  }
};

// Get data for Get All Manager
export const getAllCompanyManager = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/UserManagement/GetAllCompanyMangerByCompanyAdminId?companyadminid=${id}`
    );
    return response.data;
  } catch (error) {
    console.log(error, "--------------------------Get All Manager");
  }
};
// Get data for  Manager By id
export const getCompanyManagerById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/UserManagement/GetCompanyManagerById?id=${id}`
    );
    return response.data;
  } catch (error) {
    console.log(error, "--------------------------Get Company Manager By Id");
  }
};

// update Company Manager
export const updateCompanyManager = async (formdata) => {
  try {
    const response = await axiosInstance.post(
      "/UserManagement/UpdateCompanyManager",
      formdata
    );

    return response.data;
  } catch (error) {
    console.log(error, "--------------------------update Company Admin");
  }
};

//delete Company Manager
export const deleteCompanyManager = async (id) => {
  try {
    const response = await axiosInstance.post(
      `/UserManagement/DeleteCompanyManager?id=${id}`,
      {}
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error deleting Company Admin:",
      error.response ? error.response.data : error.message
    );
  }
};
